<div
  style="box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1)"
  class="min-w-[350px] bg-background flex items-center gap-3 rounded-md p-3 border border-border">
  <div class="toast w-full">
    <div class="progress-bar rounded-s-md" [ngClass]="type"></div>
    <div class="flex items-center gap-2 w-full">
      <app-success-icon *ngIf="type === 'success'"></app-success-icon>
      <app-info-icon *ngIf="type === 'info'"></app-info-icon>
      <app-warning-icon *ngIf="type === 'warning'"></app-warning-icon>
      <app-error-icon *ngIf="type === 'error'"></app-error-icon>
      <div>
        <h5 class="text-[13px] font-semibold text-foreground">
          {{ title }}
        </h5>
        <p class="text-[13px] font-normal text-foreground">
          {{ description }}
        </p>
      </div>
      <div *ngIf="action" class="ml-auto">
        <button
          (click)="action.onClick()"
          attr.style="{{ actionButtonStyle }}"
          class="flex min-w-[60px] items-center justify-center rounded active:translate-y-px text-xs py-1 px-2 font-semibold text-background bg-primary">
          {{ action.label }}
        </button>
      </div>
    </div>
  </div>
</div>
